import React from 'react';
import { COLOR_GREY, WHITE } from '../../constants';

const floatingThresholdProgressContainer: React.CSSProperties = {
  position: 'fixed',
  bottom: 20,
  right: 10,
  left: window.innerWidth <= 500 && 10,
  backgroundColor: WHITE,
  borderRadius: '20px',
  boxShadow: '3px 3px 10px -6px grey',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  zIndex: 1000,
  border: '1px solid lightgray',
};

const floatingThresholdTitleContainer = {
  display: 'flex',
  columnGap: 5,
  alignItems: 'center',
  paddingBottom: 10,
  padding: '10px 12px 5px 12px',
};
const floatingThresholdTitle: React.CSSProperties = {
  fontSize: window.innerWidth > 320 ? 14 : 11,
  color: '#444444',
  fontWeight: 500,
  maxWidth: '100%',
};

const floatingThresholdSubTitle = {
  fontSize: 10,
  color: COLOR_GREY,
  fontWeight: 300,
};

const styles = {
  floatingThresholdProgressContainer,
  floatingThresholdTitle,
  floatingThresholdTitleContainer,
  floatingThresholdSubTitle,
};

export default styles;
